<template>
    <section class="page-section page-section--last">
        <div class="mb-60 mb-md-30">
            <div class="mb-10"><h3 class="text-28 text-md-20">데이터분석기반 전자제조 전문인력양성</h3></div>
            <div class="row">
                <div class="col-12 col-lg-6 order-lg-2">
                    <div class="img-wrap text-lg-right">
                        <img src="/images/sub/about/business-img3.png" alt="이미지" />
                    </div>
                </div>
                <div class="col-12 col-lg-6 order-lg-1">
                    <div class="text-items">
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업명</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text">데어터분석기반 전자제조 전문인력양성</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업기간</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text">’21.3.1 ~ ’26.2.28 (5년)</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>지원내용</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text line-height-18">단기집중교육운영, 데이터 활용이 가능한 전자제조전문인력(年30명) 배출</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>사업목표</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text line-height-18">스마트전자 산업의 전자제조생태계 기반으로 현장중심의 데이터기반 전자제조 혁신 인재양성</p>
                            </div>
                        </div>
                        <div class="text-item">
                            <div class="text-item__tit text-18 text-lg-16"><strong>컨소시엄</strong></div>
                            <div class="text-item__txt">
                                <p class="page-text line-height-18">숭실대(전자), 숙명여대(경영분석), 서울과기대(데이터사이언스), KEA(제조/장비)</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="mb-30 mb-md-15">
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">1 </strong>추진목표</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <p class="card--shadow__txt page-text">
                                <span class="color-primary"
                                    >용산 전자지구의 제조장비, 생태계, 고객데이터를 활용한 교육프로그램 운영을 통해 전자+제조+데이터+경영에 대한 이해도가 높은 산업혁신인재 양성</span
                                >
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-30 mb-md-15">
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">2 </strong>추진전략</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <div class="card--shadow__txt page-text">
                                <p>1. <span class="color-primary">용산 전자지구</span> 기반 현장교육 (전자특화지역)</p>
                                <p>2. <span class="color-primary">제조장비</span>를 통한 전주기 교육 (Y-Factory77+용산상상가)</p>
                                <p>3. 대학별 특화 및 유기적 협력을 통한 <span class="color-primary">융합교육</span></p>
                                <p>4. <span class="color-primary">산학 프로젝트 및 제품 데이터</span> 분석을 통한 전문가 양성</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="card card--shadow">
                    <div class="row card--shadow__row">
                        <div class="col-12 col-lg-2">
                            <span class="card--shadow__tit text-20 text-lg-18 font-weight-medium"><strong class="color-primary">3 </strong>추진방안</span>
                        </div>
                        <div class="col-12 col-lg-10">
                            <div class="card--shadow__txt">
                                <p class="page-text">특화 집중교육 / 장비기반교육 / 지역산업교육 / 교육과정지역 신설 / 대학별 협력 / 취업 활성화</p>
                                <div class="img-wrap text-left mt-40 mt-md-10">
                                    <img src="/images/sub/about/business-img4.png" alt="이미지" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style></style>
